import rutasAmbiente from "./sources_fragmentos/rutasAmbiente";
import rutasProyectoTorre1 from "./sources_fragmentos/rutasProyectoTorre1";
import rutasProyectoTorre2 from "./sources_fragmentos/rutasProyectoTorre2";
import rutasContexto from "./sources_fragmentos/rutasContexto";
import rutasInventario from "./sources_fragmentos/rutasInventario";
import rutasSprites from "./sources_fragmentos/rutasSprites";
import rutasMapasSVG from "./sources_fragmentos/rutasMapasSVG";

export default rutasAmbiente.concat(
  rutasProyectoTorre1,
  rutasProyectoTorre2,
  rutasContexto,
  rutasInventario,
  rutasSprites,
  rutasMapasSVG
);
